import Http from '@/api/http.js'

export default {
  index(filters) {
    return Http.get('/seller_comission_configs', { params: { ...filters } })
  },

  availableSellers(ref_date) {
    return Http.get('/seller_comission_configs/available_sellers', { params: { ref_date } })
  },

  addSeller(ref_date, employee_id) {
    return Http.post('/seller_comission_configs/add_sellers', { ref_date, employee_id })
  },

  history(id) {
    return Http.get(`/seller_comission_configs/${id}/history`)
  },

  bulkUpsert(ref_date, configs) {
    return Http.post('/seller_comission_configs/bulk_upsert', { ref_date, configs })
  },

  copyFromMonth(source_ref_date, target_ref_date) {
    return Http.post('/seller_comission_configs/copy_from_month', {
      source_ref_date,
      target_ref_date,
    })
  },

  update(config) {
    return Http.put(`/seller_comission_configs/${config.id}`, {
      seller_comission_config: { ...config },
    })
  },

  destroy(id) {
    return Http.delete(`/seller_comission_configs/${id}`)
  },
}
